import React from 'react';
import { connect } from 'react-redux';
import { FormElement, TextAreaInput, TimeInput, DateInput, Button } from 'b3';
import { openModal } from '../../actions/ModalActions';
import CreateContactModal from '../../components/CreateContactModal';
import StaffMemberPicker from '../../components/StaffMemberPicker';
import ContactCardDropdown from '../../components/contact-card/ContactCardDropdown';
import { goToStep, updateScheduledCallData, completeWizard, goBack, completeWithNoFollowUpCall, emailAndCompleteWizard, saveStackedStepAndGoBack } from './logActivityReducer';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        scheduledCallData: state.logActivityWizard.scheduledCallData,
        activeScheduledCallIndex: state.logActivityWizard.activeScheduledCallIndex,
        employees: state.users.users,
        loggedCallDescription: state.logActivityWizard.callData.description
    }),
    { openModal, goToStep, updateScheduledCallData, completeWizard, completeWithNoFollowUpCall, goBack, emailAndCompleteWizard, saveStackedStepAndGoBack }
)
export default class ScheduleCallStep extends React.Component {
    componentDidMount() {
        if(document.activeElement && document.activeElement.tagName !== 'TEXTAREA') {
            this.textInput.focus();
        }
    }
    updateDate = (date) => {
        this.props.updateScheduledCallData({date});
    }
    showCreateContactModal(e) {
        e.preventDefault();
        this.props.openModal(CreateContactModal, {clientId: this.props.client.id});
    }
    canSubmit() {
        // check has date, assignedTo and Contact
    	return true;
    }
    handleContactChange(participatingContactId) {
        this.props.updateScheduledCallData({participatingContactId});
    }
    updateDescription(description) {
        this.props.updateScheduledCallData({description});   
    }
    handleEmployeeSelected(employee) {
        this.props.updateScheduledCallData({assignedEmployees: [employee]});
    }
    handleEmployeeDeselected(employee) {
        this.props.updateScheduledCallData({assignedEmployees: []});
    }
    onUserSelected(assignedEmployeeIds) {
        this.props.updateScheduledCallData({assignedEmployeeIds});
    }
    useLast = (e) => {
        e.preventDefault();
        var description = this.props.loggedCallDescription;
        this.props.updateScheduledCallData({description});   
    }
    render() {
        var { 
            client, 
            completeWizard, 
            scheduledCallData, 
            contacts, 
            activeScheduledCallIndex, 
            isInStackedStep,
            saveStackedStepAndGoBack,
            loggedCallDescription
        } = this.props;
        var { date, description, participatingContactId, assignedEmployeeIds } = scheduledCallData[activeScheduledCallIndex];

        return (
        	<div className="wizard-step-wrapper">
                <h1>Schedule Phone Call</h1>
                <div className="schedule-date-time-picker">
                    <div className="date-picker-wrapper">
                        <h2>Date</h2>
                        <FormElement icon="calendar-2" style={{minWidth: 160}}>
                            <DateInput
                                submitOnChangeOnly={true}
                                value={date}
                                onChange={this.updateDate}
                            />
                        </FormElement>
                    </div>
                    <div>
                        <h2>Time</h2>
                        <FormElement icon="clock-2">
                            <TimeInput
                                value={date}
                                onChange={this.updateDate}
                            />
                        </FormElement>
                    </div>
                </div>
                <div className="form-row">
                    <h2>
                        Assigned To
                    </h2>
                    <div>
                        <StaffMemberPicker 
                            onSelectChange={this.onUserSelected.bind(this)}
                            includeAvatarPicker={false}
                            onlyOneAssign={true} 
                            assignedUserIds={assignedEmployeeIds} 
                            callersOnly={true} />
                    </div>
                </div>
                <div>
                    <h2>Call Contact</h2>
                    <ContactCardDropdown
                        selectedContactId={participatingContactId}
                        onChange={this.handleContactChange.bind(this)}
                        contacts={contacts}
                        clientId={client.id} />
                </div>
                <div className="form-row">
                    <h2 className="agenda-with-repeat-last">
                        Agenda
                        {loggedCallDescription &&
                            <a onClick={this.useLast} href="#">Repeat Last</a>    
                        }
                    </h2>
                    <div>
                        <TextAreaInput
                            ref={el => this.textInput = el}
                            rows={3}
                            placeholder="Enter the agenda for the next call"
                            value={description} 
                            onChange={this.updateDescription.bind(this)} />
                    </div>
                </div>
                <div className="save-and-back-or-complete-wrapper">
                    {isInStackedStep &&
                        <Button
                            type="success"
                            onClick={saveStackedStepAndGoBack}
                        >
                            Save and go back
                        </Button>
                    }
                    <Button
                        disabled={! participatingContactId}
                        type="primary"
                        onClick={completeWizard}
                    >
                        Complete
                    </Button>
                </div>
        	</div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/ScheduleCallStep.js